export const getEventmessages = state => state.eventmessage.eventmessageList;
export const getEventmessageDetails = state => state.eventmessage.eventmessageDetails;
